import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.3/Types.js";
import { unit_type, bool_type, lambda_type, class_type, option_type, record_type, list_type, union_type, string_type } from "../../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { FileManagementUpdateArgs_$reflection } from "../../../FileManagement/FileManagementTypes.js";
import { UserRole_$reflection } from "../../../RAWMap.Models/Security.js";
import { StudyViewModel_$reflection } from "../../../RAWMap.Models/View/Study.js";
import { PatientCreationViewModel_$reflection, PatientViewModel_$reflection } from "../../../RAWMap.Models/View/Patient.js";
import { InstitutionViewModel_$reflection } from "../../../RAWMap.Models/View/Institution.js";
import { AnalysisViewModel_$reflection } from "../../../RAWMap.Models/View/Analysis.js";
import { DeviceOptionsViewModel_$reflection } from "../../../RAWMap.Models/View/DeviceOptions.js";
import { StentPlanScreenshots_$reflection } from "../../../Visualization/StentPlanning/StentPlanningBindings.js";
import { CompositeScreenshots_$reflection } from "../../../Visualization/StentPlanning/StentPlanningTypes.js";
import { PatientInformationViewModel_$reflection } from "../../../RAWMap.Models/View/PatientInformation.js";
import { CustomStentReportViewModel_$reflection } from "../../../RAWMap.Models/View/CustomStentReport.js";
import { FSharpChoice$2 } from "../../../fable_modules/fable-library-js.4.19.3/Choice.js";
import { Common_GeneratedReportType_$reflection, Common_ReportType_$reflection } from "../../../RAWMap.Models/Common.js";
import { ErrorMessage_$reflection } from "../../../RAWMap.Models/ErrorMessage.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.3/Result.js";

export class PromptType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Create", "Download", "Delete"];
    }
}

export function PromptType_$reflection() {
    return union_type("RAWMap.Client.Study.CustomStentReport.Prompt.Types.PromptType", [], PromptType, () => [[], [["path", string_type]], [["path", string_type]]]);
}

export class ReportPromptUpdateArgs extends Record {
    constructor(fileArgs, userRoles) {
        super();
        this.fileArgs = fileArgs;
        this.userRoles = userRoles;
    }
}

export function ReportPromptUpdateArgs_$reflection() {
    return record_type("RAWMap.Client.Study.CustomStentReport.Prompt.Types.ReportPromptUpdateArgs", [], ReportPromptUpdateArgs, () => [["fileArgs", FileManagementUpdateArgs_$reflection()], ["userRoles", list_type(UserRole_$reflection())]]);
}

export class ReportPromptInitArgs extends Record {
    constructor(selectedStudy, selectedPatient, patientInstitution, studyAnalysis, maybePreviousStudy, initUserRoles, promptType, devices, screenshots, compositeScreenshots, maybePatientInfo) {
        super();
        this.selectedStudy = selectedStudy;
        this.selectedPatient = selectedPatient;
        this.patientInstitution = patientInstitution;
        this.studyAnalysis = studyAnalysis;
        this.maybePreviousStudy = maybePreviousStudy;
        this.initUserRoles = initUserRoles;
        this.promptType = promptType;
        this.devices = devices;
        this.screenshots = screenshots;
        this.compositeScreenshots = compositeScreenshots;
        this.maybePatientInfo = maybePatientInfo;
    }
}

export function ReportPromptInitArgs_$reflection() {
    return record_type("RAWMap.Client.Study.CustomStentReport.Prompt.Types.ReportPromptInitArgs", [], ReportPromptInitArgs, () => [["selectedStudy", StudyViewModel_$reflection()], ["selectedPatient", PatientViewModel_$reflection()], ["patientInstitution", InstitutionViewModel_$reflection()], ["studyAnalysis", AnalysisViewModel_$reflection()], ["maybePreviousStudy", option_type(StudyViewModel_$reflection())], ["initUserRoles", list_type(UserRole_$reflection())], ["promptType", PromptType_$reflection()], ["devices", DeviceOptionsViewModel_$reflection()], ["screenshots", StentPlanScreenshots_$reflection()], ["compositeScreenshots", CompositeScreenshots_$reflection()], ["maybePatientInfo", option_type(PatientInformationViewModel_$reflection())]]);
}

export class SaveReportArgs extends Record {
    constructor(metadata) {
        super();
        this.metadata = metadata;
    }
}

export function SaveReportArgs_$reflection() {
    return record_type("RAWMap.Client.Study.CustomStentReport.Prompt.Types.SaveReportArgs", [], SaveReportArgs, () => [["metadata", option_type(CustomStentReportViewModel_$reflection())]]);
}

export class Operation extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DownloadingReportPdf", "GeneratingReportPdf", "UploadingReportPdf", "UpdatingMetadata", "ValidatingPatientInfo", "SavingReportPdf", "DeletingReportPdf"];
    }
}

export function Operation_$reflection() {
    return union_type("RAWMap.Client.Study.CustomStentReport.Prompt.Types.Operation", [], Operation, () => [[], [], [], [], [], [], []]);
}

export function Operation_display_51A4D834(operation) {
    switch (operation.tag) {
        case 1:
            return "Generating Report";
        case 2:
            return "Uploading Report";
        case 3:
            return "Updating Metadata";
        case 4:
            return "Validating Patient Info";
        case 5:
            return "Saving Report";
        case 6:
            return "Deleting Report";
        default:
            return "Downloading Report";
    }
}

export class Mode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Review", "RunningOperation"];
    }
}

export function Mode_$reflection() {
    return union_type("RAWMap.Client.Study.CustomStentReport.Prompt.Types.Mode", [], Mode, () => [[], [["Item", Operation_$reflection()]]]);
}

export function ModeModule_$007CDisableButtons$007CEnableButtons$007C(mode) {
    if (mode.tag === 0) {
        return new FSharpChoice$2(1, [undefined]);
    }
    else {
        return new FSharpChoice$2(0, [Operation_display_51A4D834(mode.fields[0])]);
    }
}

export function ModeModule_$007CSpinner$007CNoSpinner$007C(mode) {
    if (mode.tag === 0) {
        return new FSharpChoice$2(1, [undefined]);
    }
    else {
        return new FSharpChoice$2(0, [Operation_display_51A4D834(mode.fields[0])]);
    }
}

export class ModelReportPrompt extends Record {
    constructor(SelectedStudy, StudyAnalysis, MaybePreviousStudy, PromptType, Mode, UserRoles, PatientCreationInfo, ReportTypeToGenerate, GeneratedReportType, GenerationDateTime, Devices, StentPlanScreenshots, CompositeScreenshots, MaybePatientInfo) {
        super();
        this.SelectedStudy = SelectedStudy;
        this.StudyAnalysis = StudyAnalysis;
        this.MaybePreviousStudy = MaybePreviousStudy;
        this.PromptType = PromptType;
        this.Mode = Mode;
        this.UserRoles = UserRoles;
        this.PatientCreationInfo = PatientCreationInfo;
        this.ReportTypeToGenerate = ReportTypeToGenerate;
        this.GeneratedReportType = GeneratedReportType;
        this.GenerationDateTime = GenerationDateTime;
        this.Devices = Devices;
        this.StentPlanScreenshots = StentPlanScreenshots;
        this.CompositeScreenshots = CompositeScreenshots;
        this.MaybePatientInfo = MaybePatientInfo;
    }
}

export function ModelReportPrompt_$reflection() {
    return record_type("RAWMap.Client.Study.CustomStentReport.Prompt.Types.ModelReportPrompt", [], ModelReportPrompt, () => [["SelectedStudy", StudyViewModel_$reflection()], ["StudyAnalysis", AnalysisViewModel_$reflection()], ["MaybePreviousStudy", option_type(StudyViewModel_$reflection())], ["PromptType", PromptType_$reflection()], ["Mode", Mode_$reflection()], ["UserRoles", list_type(UserRole_$reflection())], ["PatientCreationInfo", PatientCreationViewModel_$reflection()], ["ReportTypeToGenerate", option_type(Common_ReportType_$reflection())], ["GeneratedReportType", Common_GeneratedReportType_$reflection()], ["GenerationDateTime", class_type("System.DateTimeOffset")], ["Devices", DeviceOptionsViewModel_$reflection()], ["StentPlanScreenshots", StentPlanScreenshots_$reflection()], ["CompositeScreenshots", CompositeScreenshots_$reflection()], ["MaybePatientInfo", option_type(PatientInformationViewModel_$reflection())]]);
}

export function ModelReportPrompt_get_reportTypeToGenerate_() {
    return [(m) => m.ReportTypeToGenerate, (v) => ((m_1) => (new ModelReportPrompt(m_1.SelectedStudy, m_1.StudyAnalysis, m_1.MaybePreviousStudy, m_1.PromptType, m_1.Mode, m_1.UserRoles, m_1.PatientCreationInfo, v, m_1.GeneratedReportType, m_1.GenerationDateTime, m_1.Devices, m_1.StentPlanScreenshots, m_1.CompositeScreenshots, m_1.MaybePatientInfo)))];
}

export class LocalMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ExnErrorMsg", "SetPatientCreationVm", "SetModel", "VerifyPatientInfoResult", "TryPerformReportAction", "CancelReportGenerationOrDownload", "DownloadReport", "DownloadReportResult", "CreateReport", "CreateReportResult", "UploadReport", "UploadReportResult", "CreateReportMetadata", "CreateReportMetadataResult", "SaveReport", "SaveReportResult", "DeleteReport", "DeleteReportResult"];
    }
}

export function LocalMsg_$reflection() {
    return union_type("RAWMap.Client.Study.CustomStentReport.Prompt.Types.LocalMsg", [], LocalMsg, () => [[["Item", class_type("System.Exception")]], [["Item", lambda_type(PatientCreationViewModel_$reflection(), PatientCreationViewModel_$reflection())]], [["Item", lambda_type(ModelReportPrompt_$reflection(), ModelReportPrompt_$reflection())]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [bool_type, ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", bool_type]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [], [], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [SaveReportArgs_$reflection(), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", SaveReportArgs_$reflection()]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("RAWMap.Client.Bindings.Pdf.JsPdf.JsPdfCore.Jspdf.jsPDF"), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", class_type("RAWMap.Client.Bindings.Pdf.JsPdf.JsPdfCore.Jspdf.jsPDF")]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [["Item", class_type("RAWMap.Client.Bindings.Pdf.JsPdf.JsPdfCore.Jspdf.jsPDF")]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [SaveReportArgs_$reflection(), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", SaveReportArgs_$reflection()]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [["Item", SaveReportArgs_$reflection()]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [CustomStentReportViewModel_$reflection(), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", CustomStentReportViewModel_$reflection()]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [["Item", SaveReportArgs_$reflection()]], [["Item1", SaveReportArgs_$reflection()], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ErrorMessage_$reflection()]]])]]]);
}

export class InboundMsg {
    constructor() {
    }
}

export function InboundMsg_$reflection() {
    return class_type("RAWMap.Client.Study.CustomStentReport.Prompt.Types.InboundMsg", undefined, InboundMsg);
}

export class OutboundMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CancelCustomReport", "ReportFinished"];
    }
}

export function OutboundMsg_$reflection() {
    return union_type("RAWMap.Client.Study.CustomStentReport.Prompt.Types.OutboundMsg", [], OutboundMsg, () => [[], [["Item", option_type(CustomStentReportViewModel_$reflection())]]]);
}

